module.exports = __webpack_public_path__ + "static/media/shap_tecture.f23afa97.png";